/*---------------------------------------------------------------------------------------------
Program     :  AuthService.js
Description :  Main service program for /login
Date        :  
Created By  :  jelbin
---------------------------------------------------------------------------------------------
TicketNo         Author         Date              ChangeDesc
---------------------------------------------------------------------------------------------
10062024        - Jelbin     -  10-06-2024       - Added component for logout  
---------------------------------------------------------------------------------------------*/
import axios from "axios";
import { jwtDecode } from 'jwt-decode';

class AuthService {
  login(data) {
    return axios.post("/mapandtrack/login", data)
      .catch(error => {
        console.error("Login error:", error);
        throw error;
      });
  }

  logout() {
    localStorage.removeItem("token");
    window.location.reload();
  }

  getCurrentUser() {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        return decoded;
      } catch (error) {
        console.error("Token decoding error:", error);
        return null;
      }
    }
    return null;
  }

  changePassword(data) {
    console.log("changePassword",data);
    return axios.post("/mapandtrack/changePassword", data)
      .catch(error => {
        console.error("Change password error:", error);
        throw error;
      });
  }

  forgotPassword(data) {
    return axios.post("/mapandtrack/forgotPassword", data)
      .catch(error => {
        console.error("Forgot password error:", error);
        throw error;
      });
  }  
}

const authService = new AuthService();

export default authService;